import { prefixValues } from "@/helpers"
import { AppState } from "..";
import { Module } from "vuex";
import { SummerAchievement, SummerCampaign, GetLeaderboardDataResponse, Statistics, SideQuest } from "@/models/leaderboard";

export interface LeaderboardModuleState {
    isInErrorState: boolean;
    sweepstakesEntries: number;
    statistics: Statistics;
    summerCampaigns: SummerCampaign[];
    sideQuests: SideQuest[];
    achievements: SummerAchievement;
}

const MUTATION_NAMES = {
    SET_LEADERBOARD_DATA: 'setLeaderboardData'
}

const GETTER_NAMES = {
    ORDER_COUNT: 'orderCount'
}

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'leaderboard/');
export const GETTERS = prefixValues(GETTER_NAMES, 'leaderboard/');

export function makeLeaderboardModule(): Module<LeaderboardModuleState, AppState> {
    return {
        namespaced: true,
        state: {
            isInErrorState: false,
            sweepstakesEntries: 0,
            statistics: {
                restaurantsVisited: 0,
                badgesEarned: 0,
                nationalRankPercentage: 0,
                stateRankPercentage: 0,
                stateRanked: '',
                stateCode: '',
                stateImageUri: '',
                team: '',
                favoriteEntree: '',
                favoriteEntreeImageUrl: '',
                restaurantRankPercentage: 0,
                favoriteRestaurant: {
                    numberOfOrders: 0,
                    name: '', 
                    city: '',
                    state: '',
                    crossStreets: [],
                    addressLine1: ''
                }
            },
            summerCampaigns: [],
            sideQuests: [],
            achievements: {
                totalPointsEarned: 0,
                badges: []
            }
        },
        getters: {
            orderCount(state): number {
                let orders = 0;
                state.summerCampaigns.forEach(x => { orders += x.orderCount; });
                return orders;
            }
        },
        mutations: {
            [MUTATION_NAMES.SET_LEADERBOARD_DATA](state, leaderboarddata: GetLeaderboardDataResponse) {
                state.isInErrorState = leaderboarddata.isInErrorState;
                state.sweepstakesEntries = leaderboarddata.sweepstakesEntries;
                state.statistics = leaderboarddata.statistics;
                state.summerCampaigns = leaderboarddata.summerCampaigns;
                state.sideQuests = leaderboarddata.sideQuests;
                state.achievements = leaderboarddata.achievements;
            },
        }
    }
}